<template>
  <v-content style="background-color: #f9f9f9;">
    <ValidationObserver ref="observer">
        <div class="point text-center">
          <div style="height: 90px"></div>
          <span> ポイントカード番号</span>
          <div style="height: 40px"></div>
          <v-row>
            <v-col style="display:flex">
              <ValidationProvider immediate v-slot="{ errors }" name="ポイントカード番号" rules="required|numeric|length:8">
                <v-text-field inputmode="numeric" style="width:240px" v-model="code" class="pt-0" :error-messages="errors" clear-icon="cancel" required maxlength="8"></v-text-field>
              </ValidationProvider>
              <v-img style="margin:10px auto auto -40px" @click.stop="gotoCamera()" width="32px" height="24px" src="@/assets/camera.svg"></v-img>
            </v-col>
          </v-row>
          <div style="height: 40px"></div>
          <span class="spanmessage error--text">＊ポイントカード番号が正しいことを確認の上、</span>
          <span class="spanmessage error--text">タップしてください。</span>
          <v-btn rounded class="maincolor-bg default_button2" @click.stop="setCardNumber()">登録する</v-btn>
          <div style="height: 25px"></div>
          <v-btn rounded class="caption font-weight-black" @click.stop="goBarcode()">戻る</v-btn>
        </div>
    </ValidationObserver>
    <v-overlay :value="loading">
      <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
    </v-overlay>
  </v-content>
</template>

<script>
import { required, numeric, length } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'

setInteractionMode('aggressive')
extend('required', {
  ...required,
  message: '{_field_} は必須項目です。',
})

extend('numeric', {
  ...numeric,
  message: '数字のみが利用できます。',
})

extend('length', {
  ...length,
  message: '8文字で入力してください。',
})

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  validations: {
    code: { required, numeric, length:8},
  },
  data: () => ({
    init: [],
    code: null,
    loading: false,
  }),
  created () {
    this.init = this.storageGet("*")
  },
  async mounted() {
    this.loading = true
    try {
        let input_flg = this.getUrlGetParam('input_flg')
        let code = this.getUrlGetParam('code')
        if (input_flg == 0){
          // 手入力時以外のカメラからの遷移時のエラーチェックを行う。
          // (基本的にはthis.$refs.observer.validateで問題ないが念のため独自処理も記述する。)
          let codeErrorMessage = ''
          if(code) {
            // 先頭の文字が数字以外なら削除
            if (isNaN(code.charAt(0))) {
              code = code.substring(1);
            }

            // 最後尾の文字が数字以外なら削除
            if (isNaN(code.charAt(code.length - 1))) {
              code = code.slice(0, -1);
            }

            if(code.length === 8){
              this.$refs.observer.reset()
              this.code = code
              await this.$nextTick()
              await this.$refs.observer.validate( {'silent' : true} ).then(result => {
                if (result === false) {
                  // 入力欄下部に別途メッセージが出るのでメッセージは同じに直した。
                  // エラー時はバーコード読み込みの値を放棄し入力欄をクリアする。
                  this.code = ''
                  codeErrorMessage = '読み取ったポイントカード番号が正しくありません。'
                }
              })
            }else{
              codeErrorMessage = '読み取ったポイントカード番号が正しくありません。'
            }
          }else{
            codeErrorMessage = '読み取ったポイントカード番号が正しくありません。'
          }
          if(codeErrorMessage !== ""){
            this.callDialog('エラー', codeErrorMessage, 1);
          }
        } else {
          this.$refs.observer.reset()
        }
    } catch(e) {
      this.loading = false
      this.callDialog('接続エラー', '一時的なエラーです。ネットワークの状態が不安定です。再度お試しください', 3);
    }
    this.loading = false
  },
  methods: {
    gotoCamera(){
      //ネイティブに送るデータを生成
      var tonative_req = {
        'destination': 'barcodeActivity',
        'feature_id': 'barcode',
        'screen_id': 'barcode_scan',
        'transition_type': 2,
        'barcode_format': this.init.external_point_barcode_type,  //3  DBのexternal_point_barcode_typeの値 3:NW-7(CODABAR)
        'back_url': this.getDomain() + 'sp/barcode-manager', //戻るボタン押下時のURL 不要なら削除
        'input_url': this.getDomain() + 'sp/barcode-manager/regist', //ポイントカード番号を手入力する押下時のURL
      };
      if (!(this.screenTransition(tonative_req))) {
        this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
      }
    },
    async setCardNumber() {
      this.loading = true
      await this.$refs.observer.validate().then(async result => {
        if (result) {
          var req = {params: {
              'shop_id'     : this.init.sid,
              'user_id'     : this.init.user_id,
              'card_number' : this.code,
          }}
   
          var res = await this.apiCall('/point-external/regist', req);
          this.loading = false
          if (!res) return false;
          switch (res.result_status){
            case 0:
              this.$router.push({
                name: 'barcode-manager',
                query: this.$route.query,
                force: true,
              })
              break;
            case 1:
              break;
            case 2:
              break;
          }
        }
      })
      this.loading = false
    },
    goBarcode() {
      this.$router.push({
        name: 'barcode-manager',
        query: this.$route.query,
      })
    },
  },
};
</script>

<style scoped>
.spanmessage {
  font-size: 12px;
}
.point{
  display: flex;
  flex-direction: column;
  min-height: 100%;
  align-items: center;
  justify-content: center;
}
.v-input >>> input {
  font-size: 24px;
}
</style>
<style>
.v-application--wrap {
  min-height: 100vh;
  min-height: -webkit-fill-available;
}
</style>
